// extracted by mini-css-extract-plugin
export default {"link":"navigation_link__9BNC4 lgt-button lgt-button--md lgt-button--solid","active":"navigation_active__5ULKA lgt-button--primary"};